import React, {useEffect, useRef} from 'react';
import {SketchPicker} from 'react-color';
import {useSnapshot} from 'valtio';

import state from '../../../store';

interface ColorPickerProps {
    onClose: () => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({onClose}) => {
    const snap = useSnapshot(state);
    const pickerRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
            onClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div ref={pickerRef} className='absolute left-full ml-3'>
            <SketchPicker
                color={snap.color}
                disableAlpha
                presetColors={[
                    '#000000',
                    '#353934',
                    '#ccc',
                    '#80C670',
                    '#5F3',
                    '#EFBD4E',
                    '#00008b',
                    '#5123DA',
                    '#726DE8',
                    '#7098DA',
                    '#2CCCE4',
                    '#ff8a65',
                    '#C19277',
                    '#8B0000',
                    '#512314',
                    '#5F123D',
                ]}
                onChange={(color) => (state.color = color.hex)}
            />
        </div>
    );
};

export default ColorPicker;
